import { alpha } from "@mui/material/styles"

export const styles = {
  baseCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    borderRadius: "12px",
    padding: "10px 16px",
    border: `1px solid ${theme.palette.divider}`,
    flex: 1,
    minWidth: 0,
  }),

  card: (theme) => ({
    ...styles.baseCard(theme),
    backgroundColor: theme.palette.grey.lighter4,
  }),

  whiteCard: (theme) => ({
    ...styles.baseCard(theme),
    backgroundColor: theme.palette.common.white,
  }),

  infoCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    backgroundColor: theme.palette.grey.lighter4,
    borderRadius: "10px",
    padding: "16px 20px",
    width: "fit-content",
  }),

  tipCard: (theme) => ({
    display: "flex",
    gap: 1.5,
    borderRadius: 2,
    p: 2.5,
    backgroundColor: theme.palette.peach.secondary,
    border: `1px solid ${theme.palette.peach.secondary}`,
  }),

  insightCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 3,
    borderRadius: 2,
    p: 3,
    backgroundColor: theme.palette.purple.pale,
    border: `1px solid ${theme.palette.purple.light}`,
    width: "100%",
    maxWidth: "800px",
  }),

  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  infoIconWrapper: (theme) => ({
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.info.main, 0.125),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),

  tipIconWrapper: (theme) => ({
    display: "flex",
    alignItems: "flex-start",
    mt: 0.25,
    flexShrink: 0,
    color: theme.palette.primary.main,
    fontSize: "35px",
  }),

  insightIconWrapper: (theme) => ({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: theme.palette.primary.blueBright,
    fontSize: "40px",
  }),

  iconImg: {
    width: "32px",
    height: "auto",
  },

  infoIconImg: {
    width: "38px",
    height: "auto",
  },

  textGroup: {
    display: "flex",
    flexDirection: "column",
  },

  columnCard: {
    flexDirection: "column",
    alignItems: "flex-start",
  },

  title: (theme) => ({
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    mb: 0.5,
  }),

  subtitle: (theme) => ({
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
  }),

  infoText: (theme) => ({
    color: theme.palette.text.lighter4,
    lineHeight: 1.5,
  }),

  tipTitle: (theme) => ({
    color: theme.palette.primary.dark,
    mb: 0.5,
  }),

  tipText: (theme) => ({
    color: theme.palette.primary.dark,
    lineHeight: 1.5,
  }),

  insightTitle: (theme) => ({
    color: theme.palette.primary.blue,
    fontWeight: "bold",
    mb: "4px",
  }),

  insightText: (theme) => ({
    color: theme.palette.primary.blue,
    lineHeight: 1.5,
  }),

  link: (theme) => ({
    color: theme.palette.primary.blueBright,
    cursor: "pointer",
    lineHeight: 1.3,
  }),
  successCard: (theme) => ({
    display: "flex",
    gap: 1.5,
    borderRadius: "12px",
    p: "10px 16px",
    backgroundColor: theme.palette.success.lighter,
    border: `1px solid ${theme.palette.success.muted}`,
    maxWidth: 320,
  }),
  successIconWrapper: (theme) => ({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: theme.palette.success.dark,
    fontSize: "20px",
  }),
  successTitle: (theme) => ({
    color: theme.palette.success.dark,
    fontWeight: 700,
    fontSize: "0.875rem",
    mb: 0.25,
  }),
  successText: (theme) => ({
    color: theme.palette.success.dark,
    fontSize: "0.75rem",
    lineHeight: 1.4,
  }),
  tipBlueCard: (theme) => ({
    display: "flex",
    gap: 1.5,
    borderRadius: "12px",
    p: "10px 16px",
    backgroundColor: theme.palette.primary.blueBrightBg,
    border: `1px dashed ${theme.palette.primary.blueBright}40`,
    maxWidth: 320,
  }),
  tipBlueIconWrapper: (theme) => ({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    color: theme.palette.primary.blueBright,
    fontSize: "20px",
  }),
  tipBlueTitle: (theme) => ({
    color: theme.palette.primary.blueBright,
    fontWeight: 700,
    fontSize: "0.875rem",
    mb: 0.25,
  }),
  tipBlueText: (theme) => ({
    color: theme.palette.primary.blueBright,
    fontSize: "0.75rem",
    lineHeight: 1.4,
  }),
}
